<section class="section-preview" id="preview">

  <!-- ── Cabeçalho ── -->
  <div class="preview-header">
    <div class="preview-label anim">
      <span class="preview-eyebrow">Demonstração</span>
    </div>
    <h2 class="preview-title anim anim--delay-1">Leitura Gratuita</h2>
    <div class="preview-divider anim anim--delay-2"></div>
    <p class="preview-subtitle anim anim--delay-3">
      Antes de decidir, experimente. As primeiras quarenta páginas são suas —
      sem custo, sem compromisso.
    </p>
  </div>

  <!-- ── Corpo ── -->
  <div class="preview-body">

    <!-- Capa com efeito de páginas empilhadas -->
    <div class="preview-book-col anim anim--delay-1">
      <div class="preview-cover-wrapper">
        <img
          src="assets/images/capa-breakers.jpg"
          alt="Capa – Breakers: A Queda das Chamas"
          class="preview-cover"
          loading="lazy"
        />
      </div>
      <div class="preview-pages-badge">
        <span class="pages-number">40</span>
        <span class="pages-text">páginas grátis</span>
      </div>
    </div>

    <!-- Conteúdo: destaques + barra + CTAs -->
    <div class="preview-content anim anim--delay-2">

      <p class="preview-teaser">
        Acompanhe Henshi nos primeiros passos após quatro anos de coma.
        Descubra o inicio da trama, os primeiros personagens
        e quem sabe o primeiro <i>plot twist</i> já nas primeiras páginas?
      </p>

      <ul class="preview-highlights">

        <li class="highlight-item">
          <div class="highlight-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
              <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
            </svg>
          </div>
          <div class="highlight-text">
            <strong>5 Capítulos Disponíveis</strong>
            <span>O Início da Trama</span>
          </div>
        </li>

        <li class="highlight-item">
          <div class="highlight-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
              <circle cx="9" cy="7" r="4"/>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
            </svg>
          </div>
          <div class="highlight-text">
            <strong>Personagens Principais</strong>
            <span>Conheça os personagens centrais da saga</span>
          </div>
        </li>

        <li class="highlight-item">
          <div class="highlight-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"/>
              <path d="M2 12h20"/>
              <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
            </svg>
          </div>
          <div class="highlight-text">
            <strong>Mistério e Reviravoltas</strong>
            <span>O Misterioso mundo de Breakers inicia-se aqui</span>
          </div>
        </li>

      </ul>

      <!-- Barra de progresso visual -->
      <div class="preview-progress">
        <div
          class="progress-bar"
          role="progressbar"
          aria-label="Prévia: 40 de aproximadamente 180 páginas"
          aria-valuenow="22"
          aria-valuemin="0"
          aria-valuemax="100"
        >
          <div class="progress-fill"></div>
        </div>
        <span class="progress-label">40 de ~360 páginas</span>
      </div>

      <!-- CTAs -->
      <div class="preview-ctas">
        <button class="btn-read" (click)="onReadNow()" type="button">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <polygon points="5 3 19 12 5 21 5 3"/>
          </svg>
          Ler Agora
        </button>
        <button class="btn-download" (click)="onDownload()" type="button">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
            <polyline points="7 10 12 15 17 10"/>
            <line x1="12" y1="15" x2="12" y2="3"/>
          </svg>
          Baixar PDF
        </button>
      </div>

    </div>

  </div>

</section>
